import React, { useEffect, useState } from 'react';
import { WebsiteImage } from 'components/TitleDescription';
import Button from 'components/Core/Button';
import HeroWithSubscribeForm from 'components/Sections/Hero/HeroWithSubscribeForm';
import podcastIcon from 'images/podcast-black.svg';
import SounderPlayer from '../SounderPlayer';
import { SectionContainer } from './styles';
import Bookmark from 'components/Page/Toolbox/Bookmark';

const PodcastHeroSection = ({
  backgroundImg,
  subTitle,
  title,
  description,
  coverPhoto,
  episodeId,
  detailLink,
  favorites,
  ...otherProps
}) => {
  const [formValues, setFormValues] = useState({});

  useEffect(() => {
    setFormValues({
      ...JSON.parse(localStorage.getItem('ProgressiveForm')),
    });
  }, []);

  const onSubmit = data => {
    localStorage.setItem('ProgressiveForm', JSON.stringify(data));
    setFormValues(data);
  };

  return (
    <>
      <SectionContainer backgroundImg={backgroundImg} {...otherProps}>
        <div className="section-podcast-hero--wrapper">
          <div className="section-podcast-hero--container">
            <div className="section-podcast-hero--main-container">
              <div className="section-podcast-hero-podcast-container">
                <div className="section-podcast-hero--image-side">
                  <Bookmark
                    type="podcast"
                    url={detailLink}
                    image={coverPhoto?.image}
                    title={title}
                    subTitle={subTitle}
                  >
                    <div className="section-podcast-hero--image-container">
                      <WebsiteImage
                        className="section-podcast-hero--image"
                        src={coverPhoto?.image}
                      />
                      <WebsiteImage className="section-podcast-hero--mark" src={podcastIcon} />
                      <Button
                        className="section-podcast-hero--detail-button"
                        type="primary"
                        to={detailLink}
                      >
                        Episode Details
                      </Button>
                    </div>
                  </Bookmark>
                </div>
                <div className="section-podcast-hero--text-side">
                  <p className="section-podcast-hero--subtitle">{subTitle}</p>
                  <h2 className="section-podcast-hero--title">{title}</h2>
                  <p className="section-podcast-hero--description">{description}</p>

                  {episodeId && <SounderPlayer episodeId={episodeId} />}
                </div>
              </div>
              <div className="section-podcast-hero--favorite-container">
                <h2 className="section-podcast-hero--favorite-title">
                  Get the latest episodes delivered straight to your inbox!
                </h2>
                <div className="section-podcast-hero--subscribe-container">
                  <HeroWithSubscribeForm
                    className="subscribe-without-padding"
                    title=""
                    description=""
                    background=""
                    buttonBackground="#009DE6"
                    revealProps={{
                      styles: 'section-blog-details-legal-info',
                      content: (
                        <>
                          By entering your information above and clicking this button, you agree
                          that we may contact you at the phone number or email address you provide
                          in this form. Our{' '}
                          <a href="/legal/terms-of-use" target="_blank">
                            Terms of Use
                          </a>
                          and
                          <a href="/legal/privacy-policy" target="_blank">
                            Privacy Policy
                          </a>
                          apply.
                        </>
                      ),
                    }}
                    formValues={formValues}
                    onSubmit={onSubmit}
                  />
                  <div className="section-podcast-hero--favorite-logo-container">
                    {favorites.map((item, index) => {
                      if (item.link) {
                        return (
                          <a
                            className="section-podcast-hero--favorite-logo"
                            href={item.link}
                            key={index}
                          >
                            <img
                              className="section-podcast-hero--favorite-logo-img"
                              src={item.logo}
                              alt={item.title}
                            />
                          </a>
                        );
                      }
                    })}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </SectionContainer>
    </>
  );
};

export default PodcastHeroSection;
